"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldDefNotFoundError = exports.ModalityDefNotFoundError = exports.InvalidFormatError = void 0;
/**
 * Error class to catch when the generated data does not pass the regex pattern test to check for validity
 * @param funcName - The requested format
 */
class InvalidFormatError extends Error {
    constructor(format) {
        super(`Could not generate a valid mock value using the format [${format}]`);
    }
}
exports.InvalidFormatError = InvalidFormatError;
/**
 * Throw this whenever a modality was not found for a given modality string
 * @param modalityName - The sought modality
 */
class ModalityDefNotFoundError extends Error {
    constructor(modalityName) {
        super(`ModalityDef does not exist: ${modalityName}`);
        this.name = this.constructor.name;
    }
}
exports.ModalityDefNotFoundError = ModalityDefNotFoundError;
/**
 * Throw this whenever a field definition could not be found
 * @param name - The name of the field
 */
class FieldDefNotFoundError extends Error {
    constructor(name) {
        super(`Field does not exist: ${name}`);
        this.name = this.constructor.name;
    }
}
exports.FieldDefNotFoundError = FieldDefNotFoundError;
//# sourceMappingURL=types.js.map